/* eslint-disable */
import { v4 as uuid } from 'uuid';
import { PATH_ADMIN } from 'routes/Paths';

export const DashboardMenu = [
	{
		id: uuid(),
		title: 'User Management',
		icon: 'user',
		children: [
			{ id: uuid(), link: PATH_ADMIN.admin.users, name: 'Users' },
		],
		roles: ['administrator']
	},
	{
		id: uuid(),
		title: 'Course Management',
		icon: 'book',
		children: [
			{ id: uuid(), link: '/courses/all-courses', name: 'All Courses' },
		],
		roles: ['administrator', 'reviewer']
	},
	{
		id: uuid(),
		title: 'Event Management',
		icon: 'calendar',
		children: [
			{ id: uuid(), link: '/events/all-events', name: 'All Events' },
		],
		roles: ['administrator']
	},
	// {
	// 	id: uuid(),
	// 	title: 'Site Settings',
	// 	icon: 'settings',
	// 	children: [
	// 		{ id: uuid(), link: '/settings/general', name: 'General' },
	// 		{ id: uuid(), link: '/settings/google', name: 'Google' },
	// 		{ id: uuid(), link: '/settings/social', name: 'Social' },
	// 		{ id: uuid(), link: '/settings/social-login', name: 'Social Login' },
	// 		{ id: uuid(), link: '/settings/payment', name: 'Payment' },
	// 		{ id: uuid(), link: '/settings/smtp-server', name: 'SMTP' }
	// 	],
	// 	roles: ['administrator']
	// },
];

export default DashboardMenu;
